import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=2986ff16&scoped=true&functional=true&"
var script = {}
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=2986ff16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2986ff16",
  null
  
)

export default component.exports